import React, { FC } from 'react';
import { Box, Link, TextField } from '@mui/material';
import { ADDITIONAL_FIELDS_META } from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';

type StatsUrlSectionProps = AdditionalFieldsSectionProps &
  Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    'handleTextChange' | 'handleBlur' | 'handleTextKeyDown'
  >;

export const StatsUrlSection: FC<StatsUrlSectionProps> = ({
  values,
  isFieldsDisabled,
  handleTextChange,
  handleBlur,
  handleTextKeyDown,
}) => {
  const statsUrl = values.statsUrl ?? '';
  const isValidUrl =
    typeof statsUrl === 'string' &&
    statsUrl.length > 0 &&
    /^https?:\/\//i.test(statsUrl);

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <TextField
        label={ADDITIONAL_FIELDS_META.statsUrl.label}
        variant="standard"
        fullWidth
        value={statsUrl}
        disabled={isFieldsDisabled}
        onChange={handleTextChange('statsUrl')}
        onBlur={handleBlur('statsUrl')}
        onKeyDown={handleTextKeyDown('statsUrl')}
      />
      {isValidUrl && (
        <Link href={statsUrl} target="_blank" rel="noreferrer" variant="body2">
          Открыть статистику
        </Link>
      )}
    </Box>
  );
};
